// @flow
import { makeDataset } from './types';
import type { Dataset } from './types';

export function transformDatasetToRequestData(dataset: Dataset) {
  return {
    id: dataset.id,
    name: dataset.name,

    zipcode: dataset.zipcode,
    isDeleted: dataset.isDeleted,
  };
}

export const transformResponseToDatasets = (response: any): Array<Dataset> => (
  response.data.resources.filter((x) => !x.disableRemoteAccess).map((data) => (
    makeDataset({
      clientId: data.clientId,
      id: data.id,
      name: data.name,

      platform: data.platform,
      subscriptionTier: data.subscriptionTier,
      createdByClientId: data.createdByClientId,
      createdAt: data.createdAt,
      lastSyncedAt: data.lastSyncedAt,
      zipcode: data.zipcode,

      disableRemoteAccess: data.disableRemoteAccess,
      isDeleted: data.isDeleted,
    })
  ))
);
